import React from "react";

const containerStyle = {
  textAlign: "center",
  maxWidth: "600px",
  margin: "120px auto",
  background: "#fff",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
};

const descriptionStyle = {
  fontSize: "14px",
  marginBottom: "30px",
  color: "#666",
};

const infoItemStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "15px",
  fontSize: "15px",
};

const Contact = () => {
  return (
    <div style={containerStyle}>
      <h1>Contact Us</h1>
      <p style={descriptionStyle}>
        For any operational assistance or technical issues, please reach out to
        our team through the communication channels below.
      </p>

      <div style={infoItemStyle}>
        <span role="img" aria-label="Website">
          🌐
        </span>
        <a
          href="https://apsthreeai.ai/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://apsthreeai.ai/
        </a>
      </div>

      <div style={infoItemStyle}>
        <span role="img" aria-label="Phone">
          📞
        </span>
        <a href="tel:+916356561125">+91 63565 61125</a>
      </div>

      <div style={infoItemStyle}>
        <span role="img" aria-label="Email">
          📧
        </span>
        <a href="mailto:admin@apsthreeai.ai">admin@apsthreeai.ai</a>
      </div>
    </div>
  );
};

export default Contact;